<template>
  <q-layout view="lHh Lpr lFf">
    <q-header :class="{ 'safe-area-header': needInset.android }">
      <q-toolbar>
        <div v-if="$route.name === 'taskList'">
          <q-btn
            class="absolute-left"
            flat
            color="secondary"
            @click="$router.push('/categories')"
            icon="arrow_back"
          />
        </div>

        <q-toolbar-title class="text-center">
          <img src="~assets/sowell-icon-min.png" class="sw-brand-icon" />
          <span class="sw-brand">SoWell</span>
        </q-toolbar-title>
        <q-btn
          class=""
          flat
          color="secondary"
          @click="logout"
          :icon="qrCode ? 'close' : 'exit_to_app'"
        />
      </q-toolbar>
    </q-header>

    <q-page-container>
      <sync-required></sync-required>
      <router-view />
    </q-page-container>

    <q-footer v-if="!qrCode" :class="{ 'safe-area-footer': needInset.all }">
      <q-tabs dense position="bottom" align="center" class="row">
        <q-route-tab
          :label="$t('navigation.toCreateIssue')"
          icon="send"
          to="/categories"
          class="col-4"
          exact
        />
        <q-route-tab
          v-if="showControlButton"
          :label="$t('navigation.toCreateReport')"
          icon="check_circle_outline"
          to="/zones"
          class="col-4"
          exact
        />
        <q-route-tab
          :label="$t('navigation.history')"
          icon="history"
          to="/history"
          class="col-4"
          exact
        >
          <q-badge floating color="negative" v-if="hasNotifications">{{
            notificationsCount
          }}</q-badge>
        </q-route-tab>
      </q-tabs>
    </q-footer>
  </q-layout>
</template>

<script>
import SyncRequired from 'src/components/SyncRequired'
import { mapGetters } from 'vuex'
import eventBus from 'src/eventBus'

export default {
  components: { SyncRequired },
  inject: ['$DB', '$msal'],
  data() {
    return {
      notificationsCount: 0
    }
  },
  computed: {
    ...mapGetters({
      notifications: 'reporter/notifications',
      company: 'company/attributes',
      qrCode: 'reporter/qrCode',
      needInset: 'common/needInset',
      iosDeviceClasses: 'common/iosDeviceClasses'
    }),
    showControlButton() {
      if (this.company.allowUnplannedAudits) {
        return this.company.hasAudits
      } else {
        return this.$helpers
          .decodeToken(this.$store.getters['reporter/token'])
          .roles.includes('checklister')
      }
    },
          hasNotifications() {
        return this.notificationsCount > 0
      }
  },
  methods: {
    async countNotifications() {
      // This function counts the total of notifications from which it substracts the ones
      // from issues that are not visible by the user
      await this.$DB
        .localIssues()
        .find({
          selector: {
            'meta.id': {
              $in: this.notifications.map((n) => n.id)
            }
          }
        })
        .then((results) => {
          this.notificationsCount = results.docs.length
        })
    },
    async logout() {
      const confirmLogout = await this.confirmLogout()
      if (confirmLogout) {
        if (this.qrCode) {
          window.location.assign(
            `https://portal.sowell.app/location/${this.qrCode}`
          )
          return
        }
        let notificationsSeen =
          this.$store.getters['reporter/notificationsSeen']
        if (notificationsSeen.length) {
          await this.$SowellProxy.clearReporterNotifications({
            notifications: notificationsSeen.map((notificationSeen) => {
              return {
                notification_id: notificationSeen.id,
                notification_type: notificationSeen.type,
                notification_action: notificationSeen.action
              }
            })
          })
          if (this.$q.platform.is.capacitor && this.$q.appVisible) {
            window['plugins'].OneSignal.Notifications.clearAll()
          }
          this.$store.commit('reporter/CLEAR_NOTIFICATIONS_SEEN')
        }
        eventBus.$emit('logout')
      }
    },
    async confirmLogout() {
      const hasPendingTask = await this.hasPendingTask()
      let confirmLogout = false

      if (hasPendingTask) {
        return new Promise((resolve) => {
          this.$q
            .dialog({
              title: this.$t('common.hasPendingTaskDialog.title'),
              message: this.$t('common.hasPendingTaskDialog.message'),
              cancel: true,
              persistent: true,
              ok: this.$t('common.hasPendingTaskDialog.ok'),
              cancel: {
                label: this.$t('common.hasPendingTaskDialog.cancel'),
                color: 'grey',
                flat: true
              }
            })
            .onOk(() => {
              resolve((confirmLogout = false))
              this.$router.push({ name: 'taskList' })
            })
            .onCancel(() => {
              resolve((confirmLogout = true))
            })
            .onDismiss(() => {
              resolve((confirmLogout = false))
            })
        })
      } else {
        confirmLogout = true
      }

      return confirmLogout
    },
    async reset() {
      eventBus.$emit('logout')
      eventBus.$emit('pauseQueue')

      await this.$DB.resetLocalDBs(this.$q.platform.is.capacitor)
      await this.$patrimoine.resetLocalDBs(this.$q.platform.is.capacitor)
      this.$store.dispatch('reporter/reset')
      this.$router.push({ path: '/login' })
    },
    async hasPendingTask() {
      const tmpReports = await this.$DB.tmpReports().find({
        selector: {
          status: {
            $in: ['IN_PROGRESS', 'PENDING', 'FAILED'] // NOTE: we treat failed tmpItems as well
          }
        }
      })
      const tmpIssues = await this.$DB.tmpIssues().find({
        selector: {}
      })
      return [...tmpReports.docs, ...tmpIssues.docs].length > 0
    }
  },
  watch: {
    notifications: {
      handler() {
        this.countNotifications()
      },
      deep: true
    }
  },
  beforeUnmount() {
    if (this.qrCode && this.$route.name !== 'subcategories') {
      this.$store.dispatch('reporter/setQrCode', null)
    }
  }
}
</script>
